import script from "./FolderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FolderItem.vue?vue&type=script&setup=true&lang=js"

import "./FolderItem.vue?vue&type=style&index=0&id=278693dd&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278693dd"]])

export default __exports__